<template>
    <div class="col-lg-8 col-xlg-9 col-md-7">
        <div class="card">
            <div class="card-header">
                <div class="d-md-flex align-items-center">
                    <div>
                        <h4 class="card-title"><i class="mdi mdi-percent"></i> Taxes</h4>
                        <h5 class="card-subtitle">Taxes you configure here can be applied to purchases, sales and invoices.</h5>
                    </div>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table v-middle">
                    <thead>
                    <tr class="bg-light">
                        <th class="border-top-0">#</th>
                        <th class="border-top-0">Tax</th>
                        <th class="border-top-0">Symbol</th>
                        <th class="border-top-0">Rate/s</th>
                        <th class="border-top-0">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-bind:key="index" v-for="(tax, index) in taxes">
                        <td>{{index+1}}</td>
                        <td>{{tax.name}}</td>
                        <td>{{tax.description}}</td>
                        <td>{{joinRates(tax.rates)}}</td>
                        <td>
                          <a href="javascript:void(0)" @click="taxIdToRemove = tax.tax_id" data-target="#confirmModal" data-toggle="modal"><h6 class="text-danger">Remove</h6></a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Add New Tax</h4>
                <h5 class="card-subtitle">Add new tax and rates</h5>
            </div>

            <form @submit.prevent="handleSubmit" class="form-horizontal" id="tax-form">
                <div class="card-body card-blue">
                    <div class="form-group row">
                        <label class="col-sm-3 text-right control-label col-form-label" for="tax_name">Tax</label>
                        <div class="col-sm-6">
                            <input :class="{'is-invalid': submitted && errors.has('tax_name')}" class="form-control"
                                   data-vv-as="Name"
                                   id="tax_name"
                                   name="tax_name"
                                   placeholder="Tax Name"
                                   type="text"
                                   v-model="newTax.name"
                                   v-validate="'required'">
                            <div class="invalid-feedback" v-if="submitted && errors.has('tax_name')">{{ errors.first('tax_name') }}</div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 text-right control-label col-form-label" for="tax_description">Description</label>
                        <div class="col-sm-6">
                            <textarea :class="{'is-invalid': submitted && errors.has('tax_description')}" class="form-control"
                                      data-vv-as="Description"
                                      id="tax_description"
                                      name="tax_description"
                                      placeholder="Tax Description"
                                      type="text"
                                      v-model="newTax.description"
                                      v-validate="'required'"></textarea>
                            <div class="invalid-feedback" v-if="submitted && errors.has('tax_description')">{{ errors.first('tax_description') }}</div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 text-right control-label col-form-label" for="tax_rate">Add Rate (%)</label>
                        <div class="col-sm-6">
                            <input  class="form-control"
                                   id="tax_rate"
                                   name="tax_rate"
                                   placeholder="Tax Rate"
                                   type="number"
                                   v-model="rate">
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group button-group">
                                <button @click="addRate()" class="btn btn-success" type="button" id="add_rate">
                                    <i class="fa fa-plus"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 text-right control-label col-form-label" for="tax_rate">Rates</label>
                        <div class="col-sm-6">
                            <template v-if="newTax.rates.length>0" v-for="(row, index) in newTax.rates">
                            <span class="btn btn-md btn-outline-secondary m-r-5 m-b-5">
                                {{row}}% &nbsp;<i @click="removeRate(index)" class="fa fa-times" style="cursor: pointer;"></i>
                            </span>
                            </template>
                            <label v-if="newTax.rates.length === 0" class="text-muted col-form-label">No rates added</label>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="form-group m-b-0 text-right">
                        <div class="button-group">
                            <button class="btn waves-effect waves-light btn-success" type="submit">Save</button>
                            <button @click="reset()" class="btn waves-effect waves-light btn-secondary" type="button">Reset</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>

      <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="confirmModal" role="dialog" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body card-blue">
              <div class="text-center m-t-20 m-b-10">
                <i class="fa fa-exclamation-triangle text-warning" style="font-size:50px"></i>
                <br><br>
                <h4>Are you sure you want to remove this tax?</h4>
                <button @click="removeTax()" class="btn waves-effect waves-light btn-success m-r-15" data-dismiss="modal" type="button">Yes</button>
                <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">No</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "Currencies",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {},
        data() {
            return {
                submitted: false,
                taxes: [],
                newTax: {
                    name: null,
                    description: null,
                    rates: []
                },
                rate: null,
                taxIdToRemove: null
            };
        },
        mounted() {
            this.getTaxes();
        },
        methods: {
            async getTaxes() {
                $(".preloader").fadeIn();
                let reply  = await this.$http.get(`org/${this.currentOrg.id}/taxes`);
                $(".preloader").fadeOut();
                this.taxes = reply.data;
            },
            async saveTax() {
                try {
                    console.log(this.newTax);
                    await this.$http.put(`org/${this.currentOrg.id}/taxes`, this.newTax);
                    this.$toastr('success', `Tax ${this.newTax.name} successfully added`, 'Plan Added');
                    this.reset();
                } catch(e) {
                    console.error(e);
                    this.$toastr('error', 'Could not save tax scheme', 'Failed');
                }
            },
            reset() {
                this.submitted = false;
                this.newTax = {
                    name: null,
                    description: null,
                    rates: []
                },
                this.rate = null;
            },
            async handleSubmit() {
                this.submitted = true;
                try {
                    let valid = await this.$validator.validate();
                    if(valid) {
                        await this.saveTax();
                        this.reset();
                        await this.getTaxes();
                    }
                } catch(e) {
                    console.error(e);
                }
            },
            joinRates(rates) {
                let str = '';
                rates.forEach(rate => {
                    str = str + rate.value + '%, '
                });
                str = str.substring(0, str.length - 2);
                return str;
            },
            addRate() {
                if(this.rate >= 0 && !this.newTax.rates.includes(Number(this.rate))) {
                    this.newTax.rates.push(Number(this.rate));
                    this.newTax.rates = this.newTax.rates.sort((a, b) => a - b);
                    this.rate = null;
                }
            },
            removeRate(index) {
                this.newTax.rates.splice(index, 1);
            },
          async removeTax() {
              try {
                await this.$http.delete(`org/taxes/${this.taxIdToRemove}`);
                this.$toastr('success', `Tax successfully removed`, 'Tax Removed');
                await this.getTaxes();
              }catch (e) {
                this.$toastr('error', 'Could not remove tax', 'Failed');
              }
          }
        }
    }
</script>

<style scoped>

</style>


